import React from "react";
import { ButtonProps } from "rsuite";

interface RoundedIconButtonProps extends ButtonProps {}

export function RoundedIconButton({
    children,
    className,
    ...rest
}: RoundedIconButtonProps) {
    const additionalClassName = className ?? "";
    return (
        <button
            {...rest}
            className={
                "rounded-full h-40 w-40 bg-secondary-blue-light flex justify-center items-center " +
                additionalClassName
            }
        >
            {children}
        </button>
    );
}
